import request from '../utils/backend';
import env from '../environment';
import * as actions from '../constants/customerGroupActions';
import * as events from '../constants/eventActions';

const customerGroupActions = {

    loadAll() {
        return dispatch => {
            dispatch(actions.setLoadingFlagForCustomerGroupState());

            request
                .get(env.tashi + '/customerGroups/getAll')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadCustomerGroups({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text);

                    if (data) {
                        dispatch(actions.loadCustomerGroups({ status: "success", data: data }));
                    } else {
                        dispatch(actions.loadCustomerGroups({ status: "success", data: [] }));
                    }
                });
        };
    },

    loadByProject(projectID) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForCustomerGroupState());

            request
                .get(env.tashi + '/customerGroupProjects/findByProject/' + projectID)
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadCustomerGroupsByProject({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text);

                    if (data) {
                        dispatch(actions.loadCustomerGroupsByProject({ status: "success", data: data }));
                    } else {
                        dispatch(actions.loadCustomerGroupsByProject({ status: "success", data: [] }));
                    }
                });
        };
    },

    create(customerGroupProject) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForCustomerGroupState());

            request
                .post(env.tashi + '/customerGroupProjects/new/')
                .accept('application/json')
                .withCredentials()
                .send(customerGroupProject)
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.createCustomerGroupProject({ status: "failure", data: err }));
                        return;
                    }

                    if (res.ok) {
                        customerGroupProject = JSON.parse(res.text);

                        dispatch(actions.createCustomerGroupProject({ status: "success", data: customerGroupProject }));
                    } else {
                        dispatch(actions.createCustomerGroupProject({ status: "failure", data: res.status }));
                    }
                });
        };
    },

    delete(customerGroupProject) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForCustomerGroupState());

            request
                .post(env.tashi + '/customerGroupProjects/delete/')
                .accept('application/json')
                .withCredentials()
                .send(customerGroupProject)
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.deleteCustomerGroupProject({ status: "failure", data: err }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(actions.deleteCustomerGroupProject({ status: "success", data: customerGroupProject }));
                    } else {
                        dispatch(actions.deleteCustomerGroupProject({ status: "failure", data: res.status }));
                    }
                });
        };
    },

    save(customerGroup) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForCustomerGroupState());

            request
                .post(env.tashi + '/customerGroups/save/')
                .accept('application/json')
                .withCredentials()
                .send(customerGroup)
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.saveCustomerGroup({ status: "failure", data: err }));
                        return;
                    }

                    let newCustomerGroup = JSON.parse(res.text);

                    if (res.ok) {
                        dispatch(actions.saveCustomerGroup({ status: "success", data: newCustomerGroup }));
                        dispatch(events.pushSuccessEvent({ data: "create customer group" }));
                    } else {
                        dispatch(actions.saveCustomerGroup({ status: "failure", data: res.status }));
                        dispatch(events.pushErrorEvent({ data: "create customer group" }));
                    }
                });
        };
    },

};

export default customerGroupActions;



/** WEBPACK FOOTER **
 ** ./src/app/actions/customerGroupActionCreators.js
 **/